import * as api from './account-settings-api';
import * as actions from './actions/creators';
import * as MsgBarActions from '../system-shared/message-bar-action-creator';
import { setPatientData } from '../patient/patient-middleware';
import { loadPersonalContacts } from '../personal-contacts/personal-contacts-middleware';
import { userProfileLoadedSuccess } from '../user-profile/user-profile-action-creator';
import { getPatientReminderSettings } from '../reminder-settings/reminder-settings-middleware';

export const loadPatientRegistrationDetails = (patientId) => (dispatch) =>
  api.getPatientRegistrationDetails(patientId)
    .then(
      (response) => dispatch(actions.patientRegistrationDetailsLoadSuccess(response.data)),
      (axiosResponse) => {
        const error = axiosResponse.response;
        dispatch(MsgBarActions.showErrorMessage(error.message));
      }
    );

export const updateEmail = (cred, language) => (dispatch, getState) =>
  api.changeEmail(cred, language)
    .then(() => {
      if (cred.isPatient) {
        const patient = getState().profile.patient;
        patient.emailAddress = cred.email;
        dispatch(setPatientData(patient));
        dispatch(loadPatientRegistrationDetails(cred.patientId));
        dispatch(actions.setNotificationEmail(cred.email));
        dispatch(getPatientReminderSettings(cred.patientId));
      } else {
        dispatch(loadPersonalContacts(cred.patientId));
      }
      const userState = getState().profile.user;
      userState.email = cred.email;
      dispatch(userProfileLoadedSuccess(userState));
      dispatch(MsgBarActions.showSuccessMessage('changeEmailSuccess'));
    },
    (axiosResponse) => {
      const error = axiosResponse.response;
      dispatch(MsgBarActions.showErrorMessage(error.message));
    }
    );
